import { keyframes } from '@emotion/react'

export const ctaPulse = keyframes`
    0%   { box-shadow: 0 0 0 0 rgba(0,0,0,0.2); transform: scale(1); }
    50%  { box-shadow: 0 0 0 8px rgba(0,0,0,0); transform: scale(1.03); }
    100% { box-shadow: 0 0 0 0 rgba(0,0,0,0); transform: scale(1); }
`
